import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    updatePayRequest: ['response'],
    updatePaySuccess: ['response'],
    updatePayFailure: ['error'],
})

export const updatePayTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const updatePayRequest = state => state.merge({ loading: true })

const updatePaySuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })

const updatePayFailure = (state, { response }) =>
    state.merge({
        loading: false,
        error: true,
        response,
    })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.UPDATE_PAY_REQUEST]: updatePayRequest,
    [Types.UPDATE_PAY_SUCCESS]: updatePaySuccess,
    [Types.UPDATE_PAY_FAILURE]: updatePayFailure,
})
